export function getCiVersion() {
  const version = process.env.SRC_MD5 || process.env.ARTIFACT_VERSION || '';
  return version.replace('-SNAPSHOT', '');
}
